const DEFAULT_LOADING_STATE = {
  loadingCount: 0,
}

const LOADING_STORE_NAME = 'loading'

export { DEFAULT_LOADING_STATE, LOADING_STORE_NAME }
